import React, { useState } from 'react';
import styled from 'styled-components';
import { useFieldValidation } from '../../hooks/validation-field';
import { FieldContainer, Field, Label, FieldBefore, FieldAfter } from '../field';
import { Helper } from '../Helper';
import { Icon } from '../icon';
import { makeInputText, makeCustomSup } from './mixins';
const InputText = styled.input `
  ${(props) => makeInputText(props)}
`;
const CustomSup = styled.sup `
  ${() => makeCustomSup()}
`;
const TooglePassword = styled.button `
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  background: none;
  box-shadow: none;
`;
const patterns = {
    number: '[0-9]*',
    email: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$',
    url: 'https?://.+',
};
export const Input = ({ value, placeholder = '...', name, id, type = 'text', readonly, disabled, onChange, onFocus, onBlur, onKeyPress, rules, errors, fieldOptions, noBottomMargin, }) => {
    const { fieldStates, classes, setValue, setActive } = useFieldValidation(rules, errors, name, disabled);
    const [fieldType, setFieldType] = useState(type);
    const iconSize = {
        small: 'small',
        size18: '18',
        size22: '22',
    };
    const iconColor = {
        black16: 'rgba(0, 0, 24, 0.16)',
        black: '#231F20',
    };
    const iconName = {
        password: 'password',
        eyeOpen: 'eye-open',
        eyesOff: 'eye-off',
    };
    const handleIconSize = () => {
        return (fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.size) === iconSize.small ? iconSize.size18 : iconSize.size22;
    };
    const handleIconColor = () => {
        return disabled ? iconColor.black16 : iconColor.black;
    };
    const handleIconName = () => {
        return `icon-light-${fieldType === iconName.password ? iconName.eyesOff : iconName.eyeOpen}`;
    };
    const handleOnChange = (event, callback) => {
        const { value } = event.target;
        setValue(value);
        callback && callback(event);
    };
    const handleOnBlur = (event, callback) => {
        setActive(false);
        callback && callback(event);
    };
    const handleOnFocus = (event, callback) => {
        setActive(true);
        callback && callback(event);
    };
    const togglePassword = () => {
        setFieldType(type === `password` && fieldType === type ? `text` : type);
    };
    return (React.createElement(FieldContainer, null,
        fieldOptions && fieldOptions.label && (React.createElement(Label, { htmlFor: id || `input-${name}` },
            fieldOptions.label,
            rules && rules.required && React.createElement(CustomSup, null, "*"))),
        React.createElement(Field, Object.assign({}, fieldOptions, { states: Object.assign({}, fieldStates), className: classes }),
            fieldOptions && fieldOptions.before && (React.createElement(FieldBefore, Object.assign({}, fieldOptions, { className: "field-before" }), fieldOptions.before)),
            React.createElement(InputText, Object.assign({ name: name, id: id || `input-${name}`, placeholder: placeholder, type: fieldType, inputmode: type === 'number' ? 'numeric' : type }, (patterns[type] && { pattern: patterns[type] || '' }), { disabled: disabled, readonly: readonly, value: value, autoCorrect: "off", autoCapitalize: "off", autoComplete: "off", spellcheck: "false", onChange: (event) => handleOnChange(event, onChange), onFocus: (event) => handleOnFocus(event, onFocus), onBlur: (event) => handleOnBlur(event, onBlur) }, (onKeyPress ? { onKeyPress } : {}), { ref: rules }, fieldOptions, fieldStates)),
            ((fieldOptions && Boolean(fieldOptions.after)) || type === 'password') && (React.createElement(FieldAfter, Object.assign({}, fieldOptions, { className: "field-after" }), type === 'password' ? (React.createElement(TooglePassword, { type: "button", onClick: () => !disabled && togglePassword() },
                React.createElement(Icon, { size: handleIconSize(), color: handleIconColor(), name: handleIconName() }))) : (fieldOptions && fieldOptions.after)))),
        React.createElement(Helper, { name: name, fieldOptions: fieldOptions, errors: errors, noBottomMargin: noBottomMargin })));
};
